/* ============================================================
   EXON catalog island — filter rail / mobile slide-over sheet for
   collection + search pages. NO client-side product filtering: the
   markup is a native-filter <form> (Shopify Search & Discovery). This
   island only:
     · opens/closes the mobile sheet via EXON.overlays (scroll-lock,
       esc, focus return, scrim) — mirrors the mockup fltOpen state
     · auto-submits the form when a filter changes (desktop rail only;
       on the mobile sheet the change is deferred to the Apply button)
     · mirrors the toolbar sort <select> into the form's hidden
       sort_by input and submits on change
   Idempotent; safe when the section is absent.
   ============================================================ */
(function () {
  'use strict';
  if (window.__exonCatalogInit) return;
  window.__exonCatalogInit = true;

  function init() {
    var rail = document.querySelector('[data-flt-rail]');
    var form = rail && rail.querySelector('[data-flt-form]');
    if (!rail || !form) return;

    var scrim = document.querySelector('[data-flt-scrim]');
    var openBtns = document.querySelectorAll('[data-flt-open]');
    var closeBtn = rail.querySelector('[data-flt-close]');
    var sheetMq = window.matchMedia('(max-width: 1100px)');

    /* ---- mobile slide-over sheet via the overlay manager ---- */
    var closeOverlay = null;

    function openSheet() {
      if (rail.classList.contains('open')) return;
      rail.classList.add('open');
      if (scrim) scrim.hidden = false;
      if (window.EXON && window.EXON.overlays) {
        closeOverlay = window.EXON.overlays.open('catalog-filters', {
          onClose: function () {
            rail.classList.remove('open');
            if (scrim) scrim.hidden = true;
            closeOverlay = null;
          },
        });
      }
      var first = rail.querySelector('input, button, a, select');
      if (first && first.focus) first.focus();
    }

    function closeSheet() {
      if (!rail.classList.contains('open')) return;
      if (closeOverlay) {
        closeOverlay(); /* overlay manager runs onClose (unlock + cleanup) */
      } else {
        rail.classList.remove('open');
        if (scrim) scrim.hidden = true;
      }
    }

    for (var i = 0; i < openBtns.length; i++) {
      openBtns[i].addEventListener('click', openSheet);
    }
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);
    if (scrim) scrim.addEventListener('click', closeSheet);

    /* desktop resize while the sheet is open → drop the overlay lock */
    sheetMq.addEventListener('change', function (e) {
      if (!e.matches) closeSheet();
    });

    /* ---- auto-submit on filter change (desktop rail only) ---- */
    form.addEventListener('change', function (e) {
      if (sheetMq.matches) return; /* mobile: wait for Apply */
      var el = e.target;
      if (!el) return;
      if (el.matches('input[type="checkbox"], select')) {
        form.submit();
      }
    });

    /* price inputs: submit on Enter or commit-blur (desktop only) */
    var priceInputs = form.querySelectorAll('.flt-price input');
    for (var p = 0; p < priceInputs.length; p++) {
      priceInputs[p].addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter') { ev.preventDefault(); if (!sheetMq.matches) form.submit(); }
      });
    }

    /* ---- toolbar sort <select> → mirror into hidden input, submit ---- */
    var sortMirror = form.querySelector('[data-flt-sort-mirror]');
    var sortSelects = document.querySelectorAll('[data-flt-sort]');
    for (var s = 0; s < sortSelects.length; s++) {
      sortSelects[s].addEventListener('change', function (ev) {
        if (sortMirror) sortMirror.value = ev.target.value;
        form.submit();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
